//Peticiones HTTP para temas referentes a Login y datos de usuario
import axios from 'axios';
import { AppUrls, } from './Globals';
import { Config } from './Config';
import { BodySecurityResponseForceEncripted } from '../utils'
export const authRequests = {}//Objeto agrupador de funciones

authRequests.Authentication = (data) => {//Función de autenticación
  return axios.post(
    AppUrls.Authentication,//url
    Config.SetParameters(data, '', '', ''),//Objeto a enviar al API
    Config.ConfigNoAuth()//headers
  ).then(handleResponse)//next => actions => AuthActions
    .then(userAuthenticate => {
      sessionStorage.clear()
      localStorage.clear()
      // console.log('userAuthenticate.Body.Token ', userAuthenticate.Body.Token)
      sessionStorage.setItem(//Almacenar token opcion 1: SessionStorage
        'token',
        userAuthenticate.Body.Token
      )
      sessionStorage.setItem(
        //Borrar al cerrar sesión
        "userName",
        `${userAuthenticate.Body.UserLoginData.Name} ${
          userAuthenticate.Body.UserLoginData.FatherLastName ||
          userAuthenticate.Body.UserLoginData.MotherLastName
        }`
      );
      sessionStorage.setItem(
        'WorkFlowData',
        userAuthenticate?.Body?.WorkFlowData?.WorkFlowName
      )
      localStorage.setItem(//Borrar al cerrar sesión
        'AuthData',
        userAuthenticate.Body
      )
      localStorage.setItem("TotalStageGroups", 10)
      localStorage.setItem("CurrentStageGroup", 6)

      return userAuthenticate;
    });
}

authRequests.AuthenticationEncripted = (data) => {
  // console.log("Request: ", data)
  return axios.post(
    AppUrls.Authentication,
    Config.SetParameters(data, "", "", "", true),
    Config.ConfigNoAuth()//headers
  ).then(handleResponseForceEncripted)
  .then(userAuthenticate => {
  console.log('userAuthenticate', userAuthenticate);

  sessionStorage.clear();
  localStorage.clear();

  const body = getBodyData(userAuthenticate);

  if (!body) {
    throw new Error("Body inválido o vacío");
  }

  sessionStorage.setItem(
    'token',
    body.Token
  );

  sessionStorage.setItem(
    'WorkFlowData',
    body?.WorkFlowData?.WorkFlowName
  );

  sessionStorage.setItem(
    'userName',
    `${body.UserLoginData?.Name} ${
      body.UserLoginData?.FatherLastName ||
      body.UserLoginData?.MotherLastName || ""
    }`
  );

  localStorage.setItem(
    'AuthData',
    JSON.stringify(body)
  );

  localStorage.setItem("TotalStageGroups", 10);
  localStorage.setItem("CurrentStageGroup", 6);

  return userAuthenticate;
});
}

authRequests.SSOAuthenticate = (data) => {//Función de autenticación
  return axios.post(
    AppUrls.SSOAuthenticate,//url
    Config.SetParameters(data, '', '', '', true),//Objeto a enviar al API
    Config.ConfigNoAuth()//headers
    ).then(handleResponseForceEncripted)//next => actions => AuthActions
     .then(userAuthenticate => {
      console.log("userAuthenticate: ", userAuthenticate)
      if(!userAuthenticate.Body.length) throw new Error("No se encontraron usuarios asociados a esta cuenta")
        
      //verificar que tenga roles de MesaControl
      const users = userAuthenticate.Body.filter((res) => res.UserLoginData.SecurityLoginData.Roles.some(rol => rol.Application === "OnBoarding"))
      console.log('userAuthenticateUsersPWA', users)
       if (!users || !users.length) {
          throw new Error("No es posible continuar porque no tienes permisos en la aplicación.");
        }

      sessionStorage.clear()
      localStorage.clear()
      sessionStorage.setItem('token', users[0].Token)
      sessionStorage.setItem(//Almacenar WorkFlowData SessionStorage
        'WorkFlowData',
        users[0].WorkFlowData?.WorkFlowName
      )
      sessionStorage.setItem(
        //Borrar al cerrar sesión
        "userName",
        `${users[0].UserLoginData.Name} ${
          users[0].UserLoginData.FatherLastName ||
          users[0].UserLoginData.MotherLastName
        }`
      );
      localStorage.setItem('AuthData', users[0])
      localStorage.setItem("TotalStageGroups", 10)
      localStorage.setItem("CurrentStageGroup", 6)
      
      if(users.length > 1){
        return {...userAuthenticate, Body: users[0], roles: users};
      } else{
        return {...userAuthenticate, Body: users[0]};
      }
     });
}

authRequests.RevokeUserTokens = (data) => {
  return axios.post(
    AppUrls.Disabletoken,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigNoAuth()
  ).then(handleResponse)
}

authRequests.GetClientIPsWithRefer = () => {
  return axios.get(
    AppUrls.GetClientIPsWithRefer,
    // Config.SetParameters('', "", "", "", true),
    Config.ConfigNoAuth()//headers
  ).then(handleResponse)
}


//desencripta y devuelve objeto de la respuesta del API
let handleResponse = (response) => {
  let respObject = response?.data;//BodySecurityResponse(response.data);
  if (!respObject.IsOK) {
    let responseObject = { message: respObject.Messages + ' ' + (respObject.TansactionId ? respObject.TansactionId : '') + ' ' + (respObject.statusText ? respObject.statusText : '') };
    const error = (respObject.Body || responseObject);
    return Promise.reject(error);
  }
  return respObject;
}

let handleResponseForceEncripted = (response) => {
  console.log("userAuthenticate:handleResponseForceEncripted: response: ", response)
  let respObject = BodySecurityResponseForceEncripted(response.data);
  if (!respObject.IsOK) {
    // console.log("respObject:handleResponseForceEncripted ", respObject)
    let responseObject = { message: respObject.Messages + ' ' + (respObject.TansactionId ? respObject.TansactionId : '') + ' ' + (respObject.statusText ? respObject.statusText : '') };
    const error = (respObject.Body || responseObject);
    return Promise.reject(error);
  }
  return respObject;
}

const getBodyData = (response) => {
  if (!response || !response.Body) return null;
  if (Array.isArray(response.Body) && response.Body.length === 0) return null;
  return Array.isArray(response.Body) ? response.Body[0] : response.Body;
};
